import styled from 'styled-components'
import React from 'react'
import {
    FullWidthRowFlexContainer,
    LeftColumnFlexContainer,
    LeftRowFlexContainer,
} from '../../../../../styledComponents/FlexComponents'
import PPTextField from '../../../../../components/shared/forms/PPTextField'
import {Colors, FontWeights} from '../../../../../styledComponents/Constants'
import PPCheckboxGroup from '../../../../../components/shared/forms/PPCheckboxGroup'
import { DialogTitle, TableCell, DialogActions } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import {
    AdminAlertButton,
    AdminDefaultMediumButton,
    AdminPrimaryButton,
    AdminPrimaryOutlinedButton,
} from '../../../../../styledComponents/adminPage/Buttons'
import {PageFooterArea} from '../../../../../components/shared/hoc/withAdminPageTemplate'
import {InfoOutlined} from '@mui/icons-material'
import {RESIDENT_APPLY_STATUS} from '../../../../../CodeMaster'

export const StyledTableCell = styled(TableCell)`
  &.MuiTableCell-root {
    padding-left: 24px;
    overflow-wrap: anywhere;
  }
`

export const FormLabelContainer = styled(LeftRowFlexContainer)`
  padding-bottom: 4px;
`

export const StyledApplyFormLabel = styled.div`
  font-weight: bold;
  font-size: 16px;
  color: ${Colors.AccentDark};
`

export const OutlinedTextArea =
    styled(({...props}) => (<PPTextField {...props} variant={'outlined'}/>))`
      &.MuiFormControl-root > .MuiOutlinedInput-root {
        border-radius: 0px;
        padding: 8px;
      }
    `

export const StyledHeader = styled.header`
  padding: .25rem 0 .25rem .75rem;
  border-left: 10px solid ${Colors.AdminPrimary};
`

export const StyledHeadingHr = styled.hr`
  border-style: solid;
  border-color: ${Colors.AdminPrimary};
`

export const ApplyDialogActions = withStyles({
    root: {
        padding: '16px 24px 24px 24px',
    },
})(DialogActions)

export const InfoArea = styled.div`
  background-color: ${Colors.Background};
  border: 1px solid ${Colors.AccentDark};
  border-radius: 4px;
  white-space: pre-wrap;
  display: flex;
  align-items: center;
  padding-right: 24px;
`

export const InfoOutlinedIcon = withStyles({
    root: {
        color: `${Colors.Body}`,
        fontSize: 18,
    },
})(InfoOutlined)

export const ApplyCheckbox = styled(PPCheckboxGroup)`
  & .MuiButtonBase-root {
    padding: 7px;
  }

  & .MuiCheckbox-colorPrimary.Mui-checked {
    color: ${Colors.AccentDark};
  }

  & .MuiTypography-body1 {
    font-size: 14px;
  }
`

export const ApplyPrimaryOutlinedButton = styled(AdminPrimaryOutlinedButton)<{ width?: string }>`
  &.MuiButton-root {
    font-size: 16px;
  }

  width: ${props => props.width ? `${props.width}` : '224px'};
`

export const ApplyReceptionOutlinedButton = styled(AdminPrimaryOutlinedButton)`
  &.MuiButton-root {
    font-size: 16px;
    font-weight: bold;
    color: #00838a;
    border-color: #00838a;
  }

  width: 160px;
  height: 50px;

  :disabled {
    color: ${Colors.AccentLight};
    border-color: ${Colors.AccentLight};
  }
`

export const ApplyRejectionOutlinedButton = styled(AdminPrimaryOutlinedButton)`
  &.MuiButton-root {
    font-size: 16px;
    font-weight: bold;
    color: ${Colors.Alert};
    border-color: ${Colors.Alert};
  }

  width: 160px;
  height: 50px;

  :disabled {
    color: ${Colors.AccentLight};
    border-color: ${Colors.AccentLight};
  }
`

export const ApplyPrimaryButton = styled(AdminPrimaryButton)<{ width?: string }>`
  &.MuiButton-root {
    font-size: 16px;
  }

  width: ${props => props.width ? `${props.width}` : '224px'};
`

export const ApplyAlertButton = styled(AdminAlertButton)<{ width?: string }>`
  &.MuiButton-root {
    font-size: 16px;
  }

  width: ${props => props.width ? `${props.width}` : '224px'};
`

export const StyledPageFooterArea = styled(PageFooterArea)`
  padding: 0;
`

export const DelegateApprovalButton = styled(AdminDefaultMediumButton)`
  &.MuiButtonBase-root {
    width: 288px;
    height: 40px;
  }
`

export const DialogItemNameArea = styled.div`
  font-size: 16px;
  font-weight:${FontWeights.Bold};
  color: ${Colors.AccentDark};
`
export const DelegateTag = styled.span`
  background: linear-gradient(0deg, rgba(63, 81, 181, 0.1), rgba(63, 81, 181, 0.1)),linear-gradient(0deg, #FFFFFF, #FFFFFF);
  font-size: 14px;
  padding: 4px 8px;
  line-height: 21px;
  letter-spacing: 0px;
`

export const SpDelegateApprovalButton = styled(AdminDefaultMediumButton)`
  &.MuiButtonBase-root {
    width: 100%;
    height: 50px;
  }
`

export const SpApplyDialogTitle = styled(DialogTitle)`
  &.MuiDialogTitle-root {
    padding: 16px 17px;
    border-bottom: 1px solid ${Colors.AccentLight};
  }
`

export const SpApplyDialogTitleFont = styled.div`
  font-weight: ${FontWeights.Bold};
  color: ${Colors.AccentDark};
`

export const SpBackLinkArea = styled.div`
  padding: 8px 0px 16px 0px;
`

export const SpApplicationInfoArea = styled.div`
  padding: 8px 16px;
  background-color: ${Colors.Surface};
  overflow-wrap: anywhere;
`

export const SpApplyCategory = styled.span`
  font-weight: ${FontWeights.Bold};
  font-size: medium;
`

export const SpApplyStatusCell = styled.button<{ status?: string }>`
  font-size: 12px;
  color: ${Colors.Body};
  padding: 0;
  width: 136px;
  height: 20px;
  border: 0;
  border-radius: 40px;
  background: ${props => props.status === RESIDENT_APPLY_STATUS.COMPLETE.value
          ? 'linear-gradient(0deg, rgba(0, 175, 185, 0.4), rgba(0, 175, 185, 0.4)), #FFFFFF;'
          : props.status === RESIDENT_APPLY_STATUS.REJECTION.value
                  ? 'linear-gradient(0deg, #EDEDED, #EDEDED), #FFFFFF;'
                  : 'linear-gradient(0deg, rgba(255, 191, 86, 0.4), rgba(255, 191, 86, 0.4)), #FFFFFF;'}
`

export const SpApplicationInfoFooter = styled(FullWidthRowFlexContainer)`
  padding-top: 8px;
  color: ${Colors.AccentDark};
  border-top: 1px solid ${Colors.Background};
`


export const SpApplicationDetailInfoContent = styled(LeftColumnFlexContainer)`
  padding: 16px;
  border-bottom: 2px solid ${Colors.Background};
`

export const SpApplicationDetailInfoContentName = styled.div`
  font-size: 16px;
  padding-bottom: 4px;
`

export const SpApplicationDetailInfoContentValue = styled.div`
  font-size: 16px;
  font-weight: ${FontWeights.Bold};
  overflow-wrap: anywhere;
`

export const SpPageFooterArea = styled(FullWidthRowFlexContainer)`
  padding: 32px 16px 0px 16px;
  background-color: ${Colors.Background};
`


export const SpDialogApplyProcessTag = styled.div`
  background-color: rgba(63, 81, 181, 0.1);
  border-radius: 5px;
  width: fit-content;
  padding: 4px 8px;
  margin: 0px 0px 8px 0px;
`

export const ApplyButtonTextWithIcon = styled.span`
  margin-left: 8px;
`